import Wrapper from "layouts/wrapper"
import Layout from "layouts/layout"
import Error from "components/error"
import Theme from "theme"
import Routes from "./routes"

export default function PagesIndex () {
  return (
    <Theme>
      <Wrapper>
        <Layout>
          <Error>
            <Routes />
          </Error>
        </Layout>
      </Wrapper>
    </Theme>
  )
}
